import React from "react";
import { connect } from "react-redux";

import Loader from "./../Loader/Loader.js";
import { Metric, MiniMetric, ComponentWithUrl } from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";

class Financial extends ComponentWithUrl {
  render() {
    const { loading, data } = this.props;

    if (loading) {
      return <Loader minHeight={68} col={"col-12 col-md-6"} />;
    }

    return (
      <div className="row mt-2">
        <div className="col mb-3 mb-sm-0">
          <Heading size={6} className={"mb-1"}>
            Average Account Tenure (in months) of Current Subscribers
          </Heading>
          <div className="d-flex">
            {data.avg_actual_age && data.avg_actual_age.total && (
              <Metric
                {...data.avg_actual_age.total}
                size={"lg"}
                format={"0.00"}
                type={"other"}
              />
            )}

            {data.avg_actual_age.us.value !== null &&
              data.avg_actual_age.ca.value !== null && (
                <div className="d-flex flex-column ml-4 align-self-center">
                  <MiniMetric
                    {...data.avg_actual_age.us}
                    icon={"us"}
                    format={"0.00"}
                  />

                  <MiniMetric
                    {...data.avg_actual_age.ca}
                    icon={"ca"}
                    format={"0.00"}
                  />
                </div>
              )}
          </div>
        </div>

        {/* <div className="col mb-3 mb-sm-0">
          <Heading size={6} className={"mb-1"}>
            LTV
          </Heading>
          <div className="d-flex">
            <Metric {...data.ltv.total} size={"lg"} type={'currency'} />
            <div className="d-flex flex-column ml-4 align-self-center">
              <MiniMetric {...data.ltv.us} icon={"us"} type={'currency'} />
              <MiniMetric {...data.ltv.ca} icon={"ca"} type={'currency'} />
            </div>
          </div>
        </div>

        <div className="col mb-3 mb-sm-0">
          <Heading size={6} className={"mb-1"}>
            AVG Churn (Last 30 Days)
          </Heading>
          <div className="d-flex">
            <Metric {...data.churn.total} size={"lg"} type={'percentage'} />
            <div className="d-flex flex-column ml-4 align-self-center">
              <MiniMetric {...data.churn.us} icon={"us"} type={'percentage'} />
              <MiniMetric {...data.churn.ca} icon={"ca"} type={'percentage'} / >
            </div>
          </div>
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const myState = state.data[props.url];
  return {
    data: myState ? myState.data : null,
    loading: myState ? myState.loading : true,
  };
};

export default connect(mapStateToProps)(Financial);
